import { navigation, titles } from '../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		minHeight: 300,
	},
	dataRefreshSection: {
		alignItems: 'center',
		display: 'flex',
		padding: '20px 0 0',
	},
	dataRefreshText: {
		color: titles,
		fontSize: 14,
		marginLeft: 20,
	},
	header: {
		color: navigation,
		display: 'flex',
		fontSize: 12,
		justifyContent: 'space-between',
		margin: '40px 0 20px',
	},
	headerItem: {
		padding: '0px 10px',
		width: '20%',
	},
	headerItemLarge: {
		padding: '0px 10px',
		width: '30%',
	},
	headerItemSmall: {
		padding: '0px 10px',
		width: '10%',
	},
	modalButtons: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: 20,
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginLeft: 15,
			},
			':not(:first-child)'
		),
	},
	modalWarning: {
		fontSize: 14,
		margin: '10px 0',
		maxWidth: 500,
		textOverFlow: 'wrap',
	},
	noneFound: {
		color: navigation,
		letterSpacing: 1.1,
		marginTop: 30,
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	revertCheckbox: {
		marginTop: 20,
	},
	spinnerBuffer: {
		marginTop: 30,
	},
});
